import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
import { useContext, useEffect } from 'react';
import { Header } from './Header';
import { RedirectInfotext } from './RedirectToWebsite.styles';
import Loading from '../shared/components/common/Loading';
import { getConfig } from '../config/envconfig';

export const RedirectToWebsite = () => {
    const { l } = useContext(TranslationContext);
    const config = getConfig();

    useEffect(() => {
        const redirectTimeout = () => {
            setTimeout(() => {
                window.location.href =
                    config.web_product_info ?? window.location.origin;
            }, 2000);
        };

        redirectTimeout();
    });

    return (
        <>
            <Header />
            <RedirectInfotext>
                {l('ahuDesignLite.redirectToProductSiteInfo')}
            </RedirectInfotext>
            <Loading />
        </>
    );
};
